export const MAX_CARD_AMOUNT = 25;
export const MIN_CARD_AMOUNT = 1;

export const INITIAL_CARD_AMOUNT_STATE = {
  value: 1
};

export const REDUCER_ACTIONS = {
  ADD_QUANTITY: "ADD",
  SUBTRACT_QUANTITY: "SUBTRACT",
  UPDATE_QUANTITY_ON_MOBILE_FIELD: "CONDITIONAL_ADD"
};
